import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';
import find from 'lodash/find';

import {useTags} from 'app/tags/api';
import {TagsSelect} from 'app/tags/components/TagsSelect';
import {UNLIMITED_PAGE_SIZE} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

import type {TagSerializedType} from 'sweet-types';

type Props = {
  onChange: (tagName: string) => void;
  value: string;
};

export const DashboardFilterbarTags = ({value, onChange}: Props) => {
  const selectedTags = useTags(
    value != null
      ? {
          page: '1',
          page_size: UNLIMITED_PAGE_SIZE.toString(),
          slug: value,
        }
      : skipToken
  ).data?.results;

  const convertNamesToSlugs = (tags: Array<TagSerializedType>) => {
    return onChange(tags.map((tag) => tag.slug).join(','));
  };

  const prevSelectedTags =
    value?.split(',').map((item) => ({
      name: item,
    })) || []; // creating a previously selected list of tags becuase now the allTags in case of delete is updated and previous selected tags ar not in the list.

  return (
    <TagsSelect
      lazyFetch={true}
      placeholder={gt('Filter by tag...')}
      selected={
        selectedTags?.length === prevSelectedTags?.length
          ? selectedTags
          : prevSelectedTags
      }
      onChange={convertNamesToSlugs}
    />
  );
};

export const convertStringOfSlugsToArrayOfTags = (
  slugs: string | void,
  allTags: Record<number, TagSerializedType>
): Array<TagSerializedType> =>
  (slugs || '')
    .split(',')
    .map((slug) =>
      find(allTags, {
        slug,
      })
    )
    .filter(isNotNullableValue);

function isNotNullableValue<T>(value: T): value is NonNullable<T> {
  return value != null;
}
